import { useEffect, useState } from "react";
import CommonLayout from "../../../commoncomponents/layout/CommonLayout";
import globalClasses from "../../../commoncomponents/css/Global.module.css";
import { postAxios } from "../../../../api/AxiosAPICall";
import { setSnackbar } from "../../../commoncomponents/alert/SnackbarAction";
import HpSchedulingDetails from "../hpschedulingdetails/HpSchedulingDetails";
import { Grid, Typography, Backdrop, CircularProgress } from "@mui/material";
import * as Yup from "yup";
import { useFormik } from "formik";
import moment from "moment";
import { useNavigate, useNavigationType } from "react-router-dom";
import { useDispatch } from "react-redux";

export let hpSchedulingDetailsObject = {
  userId: 0,
  userName: "",
  clinicType: "",
  clinicLocation: "",
  monday: [
    {
      isLeave: false,
      numberOfAppointment: "",
      duration: "",
      startTime: "",
      endTime: "",
      setAsDefault: false,
    },
  ],
  tuesday: [
    {
      isLeave: false,
      numberOfAppointment: "",
      duration: "",
      startTime: "",
      endTime: "",
      setAsDefault: false,
    },
  ],
  wednesday: [
    {
      isLeave: false,
      numberOfAppointment: "",
      duration: "",
      startTime: "",
      endTime: "",
      setAsDefault: false,
    },
  ],
  thursday: [
    {
      isLeave: false,
      numberOfAppointment: "",
      duration: "",
      startTime: "",
      endTime: "",
      setAsDefault: false,
    },
  ],
  friday: [
    {
      isLeave: false,
      numberOfAppointment: "",
      duration: "",
      startTime: "",
      endTime: "",
      setAsDefault: false,
    },
  ],
  saturday: [
    {
      isLeave: false,
      numberOfAppointment: "",
      duration: "",
      startTime: "",
      endTime: "",
      setAsDefault: false,
    },
  ],
  sunday: [
    {
      isLeave: false,
      numberOfAppointment: "",
      duration: "",
      startTime: "",
      endTime: "",
      setAsDefault: false,
    },
  ],
};

const HpSchedulingComponent = () => {
  let history = useNavigate();
  let navType = useNavigationType();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    return () => {
      if (navType === "POP") {
        history("/unauthenticatedUser");
      }
    };
  }, [navType, history]);

  useEffect(() => {
    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
    };
  }, []);
  const alertUser = (e: any) => {
    e.preventDefault();
    e.returnValue = "";
  };

  const finalHpSchedule = (hpSchedulingObject: any) => {
    let finalHpSchedulingObject = [] as any;

    hpSchedulingObject?.forEach((element: any) => {
      let monday: any[] = [];
      let tuesday: any[] = [];
      let wednesday: any[] = [];
      let thursday: any[] = [];
      let friday: any[] = [];
      let saturday: any[] = [];
      let sunday: any[] = [];

      element?.monday?.forEach((weekField: any, index: any) => {
        monday.push({
          numberOfAppointment: element?.monday[index].numberOfAppointment,
          appointmentDuration: element?.monday[index].duration,

          startTime:
            element?.monday[index].startTime === "" ||
            element?.monday[index].startTime === undefined ||
            element?.monday[index].startTime === null
              ? ""
              : moment(element?.monday[index].startTime).format("HH:mm") +
                ":00",

          endTime:
            element?.monday[index].endTime === "" ||
            element?.monday[index].endTime === undefined ||
            element?.monday[index].endTime === null
              ? ""
              : moment(element?.monday[index].endTime).format("HH:mm") + ":00",

          setAsDefaultTime: element?.monday[index].setAsDefault,
        });
      });
      element?.tuesday?.forEach((weekField: any, index: any) => {
        tuesday.push({
          numberOfAppointment: element?.tuesday[index].numberOfAppointment,
          appointmentDuration: element?.tuesday[index].duration,

          startTime:
            element?.tuesday[index].startTime === "" ||
            element?.tuesday[index].startTime === undefined ||
            element?.tuesday[index].startTime === null
              ? ""
              : moment(element?.tuesday[index].startTime).format("HH:mm") +
                ":00",

          endTime:
            element?.tuesday[index].endTime === "" ||
            element?.tuesday[index].endTime === undefined ||
            element?.tuesday[index].endTime === null
              ? ""
              : moment(element?.tuesday[index].endTime).format("HH:mm") + ":00",

          setAsDefaultTime: element?.tuesday[index].setAsDefault,
        });
      });

      element?.wednesday?.forEach((weekField: any, index: any) => {
        wednesday.push({
          numberOfAppointment: element?.wednesday[index].numberOfAppointment,
          appointmentDuration: element?.wednesday[index].duration,

          startTime:
            element?.wednesday[index].startTime === "" ||
            element?.wednesday[index].startTime === undefined ||
            element?.wednesday[index].startTime === null
              ? ""
              : moment(element?.wednesday[index].startTime).format("HH:mm") +
                ":00",

          endTime:
            element?.wednesday[index].endTime === "" ||
            element?.wednesday[index].endTime === undefined ||
            element?.wednesday[index].endTime === null
              ? ""
              : moment(element?.wednesday[index].endTime).format("HH:mm") +
                ":00",

          setAsDefaultTime: element?.wednesday[index].setAsDefault,
        });
      });
      element?.thursday?.forEach((weekField: any, index: any) => {
        thursday.push({
          numberOfAppointment: element?.thursday[index].numberOfAppointment,
          appointmentDuration: element?.thursday[index].duration,

          startTime:
            element?.thursday[index].startTime === "" ||
            element?.thursday[index].startTime === undefined ||
            element?.thursday[index].startTime === null
              ? ""
              : moment(element?.thursday[index].startTime).format("HH:mm") +
                ":00",

          endTime:
            element?.thursday[index].endTime === "" ||
            element?.thursday[index].endTime === undefined ||
            element?.thursday[index].endTime === null
              ? ""
              : moment(element?.thursday[index].endTime).format("HH:mm") +
                ":00",

          setAsDefaultTime: element?.thursday[index].setAsDefault,
        });
      });

      element?.friday?.forEach((weekField: any, index: any) => {
        friday.push({
          numberOfAppointment: element?.friday[index].numberOfAppointment,
          appointmentDuration: element?.friday[index].duration,

          startTime:
            element?.friday[index].startTime === "" ||
            element?.friday[index].startTime === undefined ||
            element?.friday[index].startTime === null
              ? ""
              : moment(element?.friday[index].startTime).format("HH:mm") +
                ":00",

          endTime:
            element?.friday[index].endTime === "" ||
            element?.friday[index].endTime === undefined ||
            element?.friday[index].endTime === null
              ? ""
              : moment(element?.friday[index].endTime).format("HH:mm") + ":00",

          setAsDefaultTime: element?.friday[index].setAsDefault,
        });
      });

      element?.saturday?.forEach((weekField: any, index: any) => {
        saturday.push({
          numberOfAppointment: element?.saturday[index].numberOfAppointment,
          appointmentDuration: element?.saturday[index].duration,

          startTime:
            element?.saturday[index].startTime === "" ||
            element?.saturday[index].startTime === undefined ||
            element?.saturday[index].startTime === null
              ? ""
              : moment(element?.saturday[index].startTime).format("HH:mm") +
                ":00",

          endTime:
            element?.saturday[index].endTime === "" ||
            element?.saturday[index].endTime === undefined ||
            element?.saturday[index].endTime === null
              ? ""
              : moment(element?.saturday[index].endTime).format("HH:mm") +
                ":00",

          setAsDefaultTime: element?.saturday[index].setAsDefault,
        });
      });
      element?.sunday?.forEach((weekField: any, index: any) => {
        sunday.push({
          numberOfAppointment: element?.sunday[index].numberOfAppointment,
          appointmentDuration: element?.sunday[index].duration,

          startTime:
            element?.sunday[index].startTime === "" ||
            element?.sunday[index].startTime === undefined ||
            element?.sunday[index].startTime === null
              ? ""
              : moment(element?.sunday[index].startTime).format("HH:mm") +
                ":00",

          endTime:
            element?.sunday[index].endTime === "" ||
            element?.sunday[index].endTime === undefined ||
            element?.sunday[index].endTime === null
              ? ""
              : moment(element?.sunday[index].endTime).format("HH:mm") + ":00",

          setAsDefaultTime: element?.sunday[index].setAsDefault,
        });
      });

      let newData = {
        useUsername: element.userName,
        clinicType: element.clinicType.split("@~@@").shift(),
        clinicLocation: element.clinicLocation.split("@~@@").shift(),
        monday: monday,
        tuesday: tuesday,
        wednesday: wednesday,
        thursday: thursday,
        friday: friday,
        saturday: saturday,
        sunday: sunday,
      };

      finalHpSchedulingObject.push(newData);
    });
    return finalHpSchedulingObject;
  };
  const generateHpSchedulingObject = async (hpSchedulingObject: any) => {
    setOpen(true);
    const response = await postAxios(
      "establishment/register/hpScheduling",
      {
        hpScheduleJsons: finalHpSchedule(hpSchedulingObject),
      },
      {}
    );

    if (response.toString() === "ERROR") {
      setOpen(false);
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cellmaflex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response.toString() !== "" && typeof response !== "object") {
      setOpen(false);
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
    } else {
      setOpen(false);
      dispatch(
        setSnackbar(
          true,
          4000,
          "success",
          "Registration is completed successfully!",
          "top",
          "center"
        )
      );

      history("/ViewPlans", { state: { estId: response.data } });
    }
  };

  const formik = useFormik({
    initialValues: hpSchedulingDetailsObject,
    validationSchema: Yup.object({
      userName: Yup.string().required("Please enter username."),
      clinicType: Yup.string().required("Please select clinic type"),
      clinicLocation: Yup.string().required("Please select clinic location"),

      monday: Yup.array().of(
        Yup.object().shape({
          numberOfAppointment: Yup.string().when("isLeave", {
            is: false,
            then: () =>
              Yup.string().required("Please select number of appointment"),
          }),
          duration: Yup.string().when("isLeave", {
            is: false,
            then: () => Yup.string().required("Please select duration"),
          }),
          startTime: Yup.string()
            .nullable()
            .when("isLeave", {
              is: false,
              then: () =>
                Yup.string()
                  .nullable()
                  .required("Please select start time")
                  .test(
                    "startTime",
                    "startTime",
                    (value: any, context: any) => {
                      return true;
                    }
                  ),
            }),

          endTime: Yup.string()
            .nullable()
            .when("isLeave", {
              is: false,
              then: () =>
                Yup.string()
                  .nullable()
                  .required("Please select end time")
                  .test(
                    "endTime",
                    "End Time must be more than Start Time",
                    (value: any, context: any) => {
                      if (
                        value !== undefined &&
                        context.parent.startTime !== undefined &&
                        context.parent.startTime !== null &&
                        context.parent.endTime !== undefined &&
                        context.parent.endTime !== null
                      ) {
                        return moment(context?.parent?.endTime).isAfter(
                          moment(context?.parent?.startTime)
                        );
                      }
                      return true;
                    }
                  ),
            }),
        })
      ),

      tuesday: Yup.array().of(
        Yup.object().shape({
          numberOfAppointment: Yup.string().when("isLeave", {
            is: false,
            then: () =>
              Yup.string().required("Please select number of appointment"),
          }),
          duration: Yup.string().when("isLeave", {
            is: false,
            then: () => Yup.string().required("Please select duration"),
          }),
          startTime: Yup.string()
            .nullable()
            .when("isLeave", {
              is: false,
              then: () =>
                Yup.string()
                  .nullable()
                  .required("Please select start time")
                  .test(
                    "startTime",
                    "startTime",
                    (value: any, context: any) => {
                      return true;
                    }
                  ),
            }),

          endTime: Yup.string()
            .nullable()
            .when("isLeave", {
              is: false,
              then: () =>
                Yup.string()
                  .nullable()
                  .required("Please select end time")
                  .test(
                    "endTime",
                    "End Time must be more than Start Time",
                    (value: any, context: any) => {
                      if (
                        value !== undefined &&
                        context.parent.startTime !== undefined &&
                        context.parent.startTime !== null &&
                        context.parent.endTime !== undefined &&
                        context.parent.endTime !== null
                      ) {
                        return moment(value).isAfter(
                          moment(context.parent.startTime)
                        );
                      }
                      return true;
                    }
                  ),
            }),
        })
      ),
      wednesday: Yup.array().of(
        Yup.object().shape({
          numberOfAppointment: Yup.string().when("isLeave", {
            is: false,
            then: () =>
              Yup.string().required("Please select number of appointment"),
          }),
          duration: Yup.string().when("isLeave", {
            is: false,
            then: () => Yup.string().required("Please select duration"),
          }),
          startTime: Yup.string()
            .nullable()
            .when("isLeave", {
              is: false,
              then: () =>
                Yup.string()
                  .nullable()
                  .required("Please select start time")
                  .test(
                    "startTime",
                    "startTime",
                    (value: any, context: any) => {
                      return true;
                    }
                  ),
            }),

          endTime: Yup.string()
            .nullable()
            .when("isLeave", {
              is: false,
              then: () =>
                Yup.string()
                  .nullable()
                  .required("Please select end time")
                  .test(
                    "endTime",
                    "End Time must be more than Start Time",
                    (value: any, context: any) => {
                      if (
                        value !== undefined &&
                        context.parent.startTime !== undefined &&
                        context.parent.startTime !== null &&
                        context.parent.endTime !== undefined &&
                        context.parent.endTime !== null
                      ) {
                        return moment(value).isAfter(
                          moment(context.parent.startTime)
                        );
                      }
                      return true;
                    }
                  ),
            }),
        })
      ),

      thursday: Yup.array().of(
        Yup.object().shape({
          numberOfAppointment: Yup.string().when("isLeave", {
            is: false,
            then: () =>
              Yup.string().required("Please select number of appointment"),
          }),
          duration: Yup.string().when("isLeave", {
            is: false,
            then: () => Yup.string().required("Please select duration"),
          }),
          startTime: Yup.string()
            .nullable()
            .when("isLeave", {
              is: false,
              then: () =>
                Yup.string()
                  .nullable()
                  .required("Please select start time")
                  .test(
                    "startTime",
                    "startTime",
                    (value: any, context: any) => {
                      return true;
                    }
                  ),
            }),

          endTime: Yup.string()
            .nullable()
            .when("isLeave", {
              is: false,
              then: () =>
                Yup.string()
                  .nullable()
                  .required("Please select end time")
                  .test(
                    "endTime",
                    "End Time must be more than Start Time",
                    (value: any, context: any) => {
                      if (
                        value !== undefined &&
                        context.parent.startTime !== undefined &&
                        context.parent.startTime !== null &&
                        context.parent.endTime !== undefined &&
                        context.parent.endTime !== null
                      ) {
                        return moment(value).isAfter(
                          moment(context.parent.startTime)
                        );
                      }
                      return true;
                    }
                  ),
            }),
        })
      ),

      friday: Yup.array().of(
        Yup.object().shape({
          numberOfAppointment: Yup.string().when("isLeave", {
            is: false,
            then: () =>
              Yup.string().required("Please select number of appointment"),
          }),
          duration: Yup.string().when("isLeave", {
            is: false,
            then: () => Yup.string().required("Please select duration"),
          }),
          startTime: Yup.string()
            .nullable()
            .when("isLeave", {
              is: false,
              then: () =>
                Yup.string()
                  .nullable()
                  .required("Please select start time")
                  .test(
                    "startTime",
                    "startTime",
                    (value: any, context: any) => {
                      return true;
                    }
                  ),
            }),

          endTime: Yup.string()
            .nullable()
            .when("isLeave", {
              is: false,
              then: () =>
                Yup.string()
                  .nullable()
                  .required("Please select end time")
                  .test(
                    "endTime",
                    "End Time must be more than Start Time",
                    (value: any, context: any) => {
                      if (
                        value !== undefined &&
                        context.parent.startTime !== undefined &&
                        context.parent.startTime !== null &&
                        context.parent.endTime !== undefined &&
                        context.parent.endTime !== null
                      ) {
                        return moment(value).isAfter(
                          moment(context.parent.startTime)
                        );
                      }
                      return true;
                    }
                  ),
            }),
        })
      ),

      saturday: Yup.array().of(
        Yup.object().shape({
          numberOfAppointment: Yup.string().when("isLeave", {
            is: false,
            then: () =>
              Yup.string().required("Please select number of appointment"),
          }),
          duration: Yup.string().when("isLeave", {
            is: false,
            then: () => Yup.string().required("Please select duration"),
          }),
          startTime: Yup.string()
            .nullable()
            .when("isLeave", {
              is: false,
              then: () =>
                Yup.string()
                  .nullable()
                  .required("Please select start time")
                  .test(
                    "startTime",
                    "startTime",
                    (value: any, context: any) => {
                      return true;
                    }
                  ),
            }),

          endTime: Yup.string()
            .nullable()
            .when("isLeave", {
              is: false,
              then: () =>
                Yup.string()
                  .nullable()
                  .required("Please select end time")
                  .test(
                    "endTime",
                    "End Time must be more than Start Time",
                    (value: any, context: any) => {
                      if (
                        value !== undefined &&
                        context.parent.startTime !== undefined &&
                        context.parent.startTime !== null &&
                        context.parent.endTime !== undefined &&
                        context.parent.endTime !== null
                      ) {
                        return moment(value).isAfter(
                          moment(context.parent.startTime)
                        );
                      }
                      return true;
                    }
                  ),
            }),
        })
      ),

      sunday: Yup.array().of(
        Yup.object().shape({
          numberOfAppointment: Yup.string().when("isLeave", {
            is: false,
            then: () =>
              Yup.string().required("Please select number of appointment"),
          }),
          duration: Yup.string().when("isLeave", {
            is: false,
            then: () => Yup.string().required("Please select duration"),
          }),
          startTime: Yup.string()
            .nullable()
            .when("isLeave", {
              is: false,
              then: () =>
                Yup.string()
                  .nullable()
                  .required("Please select start time")
                  .test(
                    "startTime",
                    "startTime",
                    (value: any, context: any) => {
                      return true;
                    }
                  ),
            }),

          endTime: Yup.string()
            .nullable()
            .when("isLeave", {
              is: false,
              then: () =>
                Yup.string()
                  .nullable()
                  .required("Please select end time")
                  .test(
                    "endTime",
                    "End Time must be more than Start Time",
                    (value: any, context: any) => {
                      if (
                        value !== undefined &&
                        context.parent.startTime !== undefined &&
                        context.parent.startTime !== null &&
                        context.parent.endTime !== undefined &&
                        context.parent.endTime !== null
                      ) {
                        return moment(value).isAfter(
                          moment(context.parent.startTime)
                        );
                      }
                      return true;
                    }
                  ),
            }),
        })
      ),
    }),
    onSubmit: () => {},
  });
  return (
    <CommonLayout>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <Typography variant="h1" className={globalClasses.pageTitle}>
            Add Hp Appointment Schedule
          </Typography>
        </Grid>
      </Grid>
      <HpSchedulingDetails
        formik={formik}
        hpSchedulingData={generateHpSchedulingObject}
      />

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={open}
        onClick={() => {
          setOpen(false);
        }}
      >
        <CircularProgress
          color="inherit"
          onClick={() => {
            setOpen(false);
          }}
        />
      </Backdrop>
    </CommonLayout>
  );
};

export default HpSchedulingComponent;
